import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from "@material-ui/core/Grid";
import Box from '@material-ui/core/Box';
import { Link, Typography } from '@material-ui/core';
import SessionDetails from './SessionDetails';
import CoachingAgreementForm from './CoachingAgreementForm';
import LeadershipCompetency from './LeadershipCompetency';
import EvaluationForm from './EvaluationForm';
import Costs from './Costs';
import SLA from './SLA';
import HeaderMenu from '../../../../../Components/HeaderMenu';
import CloseIcon from '@material-ui/icons/Close';
import DataService from "../../../../../Service";
import { useLocation, useHistory, withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    tabRoot: {

        '& .MuiTabs-flexContainer': {
            justifyContent: "flex-start",
        },
        '& .MuiTabs-indicator': {
            backgroundColor: "transparent",
        }
    },
    tabs: {
        color: "#1e1e1e",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: "#ddd",
        backgroundColor: "rgba(7,127,131,.75)",
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        marginRight: 10,
        fontSize: "16px",
        minWidth: 130,
        textTransform: "none",
        "&.Mui-selected,&:hover": {

            color: sessionStorage.getItem('role') == 'admin' ? "#fff" : '#fff',
            opacity: 1,
            backgroundColor: sessionStorage.getItem('role') == 'admin' ? "rgba(7,127,131,1)" : 'rgba(7,127,131,1)',
        }
    },
    closeIconClass: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    circleClass: {
        height: '10px',
        width: '10px',
        backgroundColor: theme.palette.secondary.main,
        borderRadius: '50%',
        marginRight: '1rem',
        boxShadow: '0 0 0px 3px rgb(152 27 30 / 25%)'
    },
    btnSummary: {
        backgroundColor: theme.palette.secondary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main
        }
    }

}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <Box role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`} {...other}>
            {value === index && children}
        </Box>
    );
}

const AssignmentSummary = (props) => {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();

    const [value, setValue] = React.useState(sessionStorage.getItem("pathname")=== "/admin/reports" ? 1 :0);
    sessionStorage.removeItem("pathname");
    const [sessionDetail, setSessionDetail] = useState(undefined);
    const [SLAData, setSLAData] = useState([]);

    useEffect(() => {
        if (value == 0 || value === 1) {
            fetchSessionDetail();
        }
    }, [value])

    useEffect(() => {
        if (value == 4) {
            fetchSLADetail()
        }
    }, [value])

    const fetchSessionDetail = () => {
        let param = {
            assignment_id: location?.state?.currentAssignment?.id
        };
        DataService.getData(param, 'session_detail').then((res) => {
            if (res?.success) {
                setSessionDetail(res);
            }
        }).catch((error) => {
            console.log("error =>", error)
        })
    }

    const fetchSLADetail = () => {
        let param = {
            assignment_id: location?.state?.currentAssignment?.id
        };
        DataService.getData(param, 'SLA_detail').then((res) => {
            if (res?.success) {
                setSLAData(res?.['SLA_details'])
            }
        }).catch((error) => {
            console.log("error =>", error)
        })
    }
     const globaluserData = useSelector((state) => state.commonReducer);
     let userRole = globaluserData.role;
// const userRole=sessionStorage.getItem("role")
    const tabArr = ["Session details", "Coaching agreement form", "Evaluation form", "Costs", "SLA"].map((el)=>{
          if(userRole!=="admin"){
             if(el==="SLA"){
                return  ;
             }else{
                return el ;
             }
          }else{
            return el;
          }
    }).filter(el=>el!==undefined)

    const tabPanelArr = [
        <SessionDetails sessionDetail={sessionDetail} {...props} />,
        <CoachingAgreementForm id={location?.state?.currentAssignment?.id} />,
        // <LeadershipCompetency />,
        <EvaluationForm id={location?.state?.currentAssignment?.id} />,
        <Costs id={location?.state?.currentAssignment?.id} />,
        <SLA {...props} SLAData={SLAData} fetchSLADetail={fetchSLADetail} />
    ];

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return <>
        <HeaderMenu />
        <Box m={4} p={4} boxShadow={2}>
            <Grid container direction="row" justify="center" alignItems="center">

                <Grid item xs={12}>
                    <Box mb={3}>
                        <Grid container direction="row" justify="center" alignItems="center">

                            <Grid item xs={4} lg={5} style={{ textAlign: "center" }}>
                                <Typography variant="h1" style={{ color: "#4A4A4A" }}>
                                    <Box textAlign="left" fontWeight="fontWeightBold">Assignment
                                        summary {sessionDetail?.assignment_name ? `( ${sessionDetail?.assignment_name} )` : ""}</Box>
                                </Typography>
                            </Grid>
                            <Grid xs={4} container>
                                <Typography variant="h1" style={{ color: "#757575" }}>
                                    <Box textAlign="left">Organization:&nbsp;</Box>
                                </Typography>
                                <Typography variant="h1">
                                    <Box textAlign="left" style={{ color: "#4A4A4A", fontWeight: "bold" }}>{sessionDetail?.organisation_name || ""}</Box>
                                </Typography>
                            </Grid>
                            <Grid item lg={3} md={3}>
                                <Typography variant="h6" style={{ color: "#4A4A4A" }}>
                                    <Box className={classes.closeIconClass}>
                                        <Button color="secondary" className={classes.btnSummary}
                                            style={{
                                                textTransform: 'none',
                                                color: "#fff",
                                                verticalAlign: "top",
                                                marginRight: 10,
                                                padding: "10px"
                                            }}
                                            onClick={() => {
                                                props.history.push({
                                                    pathname: '/assignmentoverview',
                                                    state: { currentAssignment: location?.state?.currentAssignment }
                                                })
                                            }} >Assignment overview</Button>
                                        <Button onClick={() => {
                                            props.history.push({
                                                pathname: '/assignmentoverview',
                                                state: { currentAssignment: location?.state?.currentAssignment }
                                            })
                                        }} color="inherit">
                                            <CloseIcon fontSize="small" color='' />
                                        </Button>
                                    </Box>
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Box mt={2}>
                                    <Grid item xs={4}>
                                        <Typography variant="subtitle1" style={{ color: "#EF7000" }}>
                                            <Box direction="row" alignItems="center" display="flex" textAlign="left">
                                                <div className={classes.circleClass}></div>
                                                Assignment
                                                status {sessionDetail?.assignment_status ? `- ${sessionDetail?.assignment_status}` : ''}
                                            </Box>
                                        </Typography>
                                    </Grid>
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <Box my={5}>
                                    <Tabs value={value} onChange={handleChange} classes={{ root: classes.tabRoot }}>
                                        {
                                          tabArr.map((option) => <Tab classes={{ root: classes.tabs }} label={option} /> )
                                        }
                                    </Tabs>
                                    {
                                        tabPanelArr.map((option, index) => <TabPanel value={value}
                                            index={index}>{option}</TabPanel>)
                                    }
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid >
        </Box >
    </>
}

export default withRouter(AssignmentSummary);



